import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const rotateCollapseButton = css({
  transform: `rotate(180deg)`,
  transition: 'transform 0.2s',
});

export const trayTopBarStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(0, 1),
  borderBottom: `1px solid ${theme.colors.neutral20}`,
});
